export class InfractionType {
    id:string;
    name:string;
    description:string;

    order:number;

    constructor(other ?:InfractionType) {
        if (other) {
            this.id = other.id;
            this.name = other.name;
            this.description = other.description;

            this.order = other.order;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/infractionType.ts
 **/